export function ConvertToMerchantDetail(detail: any) {
  return detail;
}
